import React, { useState } from 'react'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
const axios = require('axios').default;
const { api, apiKey, authEndpoint, apiEndpoint } = require('../../../config')

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialog: {
            marginTop: 120,
            minHeight: 400
        },
        form: {
            display: 'flex',
            flexDirection: 'column',
            margin: 'auto',
            width: 'fit-content',
        },
        formControl: {
            minWidth: 600,
            minHeight: 400
        },
        queryDiv: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: 10
        },
        queryHeading: {
            fontSize: 14,
            fontWeight: 'bold',
            textTransform: 'capitalize',
            width: '30%'
        },
        queryText: {},
        formControlLabel: {
            marginTop: theme.spacing(1),
        },
    }),
);
function SearchModal(props: any) {
    const classes = useStyles();
    const { isVisible, handleClose, data } = props;
    const [filterName, setfilterName] = useState("")
    const handleSaveQuery = async () => {
        if(!filterName)
        {
            alert("Please enter Query name")
            return
        }
        let saveData = {
            id: props.id,
            filterName,
            filterQuery: data
        }
        await axios({
            method: 'POST',
            url: `${apiEndpoint}/users/save-filters`,
            data: saveData,
            headers: props.headers
        }).then((response: any) => {
            if (response && response.data) {
                props.handleClose();
                props.getSearchFilters()
            }
        }).catch((err: any) => {
            console.log({ err })
        })

    }
    return (
        <div style={{ marginTop: 80 }}>
            <Dialog
                className={classes.dialog}
                open={isVisible} onClose={handleClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Save The Search Query</DialogTitle>
                <DialogContent className={classes.formControl}>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Query Name"
                        type="text"
                        fullWidth
                        onChange={(e) => setfilterName(e.target.value)}
                    />
                    {data && Object.keys(data).map((item) => <div className={classes.queryDiv}>
                        <div className={classes.queryHeading}>{item}</div>
                        <div className={classes.queryDiv}>{data?.[item]?.toString()}</div>
                    </div>)}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary"> Cancel </Button>
                    <Button onClick={handleSaveQuery} color="primary">Save Query</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default SearchModal